import { render, staticRenderFns } from "./SidebarSection.vue?vue&type=template&id=057b436a&"
import script from "./SidebarSection.vue?vue&type=script&lang=js&"
export * from "./SidebarSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports